module.exports = __webpack_public_path__ + "img/Newbie_Bow_02_Ranger.29e951dc.png";